import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var PropInfo =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PropInfo, _PureComponent);

  function PropInfo() {
    _classCallCheck(this, PropInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropInfo).apply(this, arguments));
  }

  _createClass(PropInfo, [{
    key: "render",
    value: function render() {
      return React.createElement("tr", null, React.createElement("td", null, React.createElement("code", null, this.props.name)), React.createElement("td", null, this.props.type), React.createElement("td", null, this.props["default"]), React.createElement("td", null, this.props.description));
    }
  }]);

  return PropInfo;
}(PureComponent);

export { PropInfo as default };
PropInfo.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  "default": PropTypes.string.isRequired,
  description: PropTypes.node
};